// O vue-i18n usa pt_BR e o Intl so aceita a tag BCP 47 (pt-BR).
const intlLocale = locale => locale.replace('_', '-');

export const formatTicketDateTime = (timestamp, locale) =>
  new Intl.DateTimeFormat(intlLocale(locale), {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(new Date(timestamp * 1000));

export const formatTicketDate = (isoDate, locale) =>
  new Intl.DateTimeFormat(intlLocale(locale), { dateStyle: 'short' }).format(
    new Date(`${isoDate}T00:00:00`)
  );
